class UGCountdownTimer extends HTMLElement {
    constructor() {
        super();
        // 传进来的参数
        this.loca_timezone = null; // 设置倒计时的时区 西8区：-8、 东8区：8
        this.set_coundown = null; // 倒计时的结束时间  格式 2024-01-01 00:00:00
        this.defalut_text = null; // 倒计时的文本 'Days;;;Hrs;;;Mins;;;Secs'
        this.now_date = null; // 服务器当前时间 带时区 2024-11-14 13:42:08 CST
        this.defalut_text_split = null; // 倒计时的文本分隔符
        this.stopCallback = null; // 倒计时结束后的回调函数
        
        // 进行计算后的值
        this.serverLastTime = null // 服务器 结束的时间戳 【已经和服务器的时区 配平】
        this.serverNowTime = null // 服务器 当前的时间戳
        this.countdownTime = null // 配平后的 时间戳 差值

        this.lastUpdateTime = 0 // 上次更新时间 用来存储每一次调用requestAnimationFrame的时间戳
        this.endDJS = null // 倒计时结束的时间戳
        this.animationFrameId = null // requestAnimationFrame的id
        this.initCallbackFn = null // init后的回调 如果有
        this.stopAfterCallbackFn = null // 结束倒计时回调 如果有  外面直接：元素.callbackFn = function(){} 即可传入
    }

    connectedCallback() {
        //  获取自定义元素的属性
        this.loca_timezone = this.getAttribute('loca_timezone') || 8; // 设置倒计时的时区
        this.set_coundown = this.getAttribute('set_coundown'); // 倒计时的结束时间  格式 2022-01-01 00:00:00
        this.defalut_text = this.getAttribute('defalut_text') || 'Days;;;Hrs;;;Mins;;;Secs'; // 倒计时的文本
        this.now_date = this.getAttribute('now_date'); // 服务器当前时间 带时区
        this.defalut_text_split = this.getAttribute('defalut_text_split') || ';;;'; // 倒计时的文本分隔符

        // 初始化
        this.getServerTime(); // 将设置的结束时区 与 服务器的时时区 配平

        // 创建并插入倒计时的 HTML 结构
        let list = ["days","hours","minutes","seconds"];
        let defalut_text_list = this.defalut_text.split(this.defalut_text_split);
        let listdiv = '';
        for(let i = 0; i < list.length; i++){
        listdiv = listdiv + `<div class="ug-countdown-item ug-countdown-item-${list[i]}">
                        <span class="ug-countdown-item-val countdown-${list[i]}">00</span>  
                        <span class="ug-countdown-item-test">${defalut_text_list[i]}</span>
                    </div>`
        }
        this.innerHTML = `<div class="ug-countdown-div dpn">
                            ${listdiv}
                        </div>`

        this.startCountdown(); // 启动倒计时
        setTimeout(() => {
            if (this.initCallbackFn && typeof this.initCallbackFn === 'function') {
                this.initCallbackFn();  // 调用传递的回调函数
            }
        },1100);
        
    }

    // 将设置的结束时区 与 服务器的时时区 配平 并计算出差值
    getServerTime() {
        let ug_now = new Date(this.now_date);
        let timezoneOffset = ug_now.getTimezoneOffset() / 60 * (-1); // 获取服务器时区偏移量 [世界时区时间 - 当前时区时间] 所以东8区 +8 返回的是 -8
        this.serverNowTime = ug_now.getTime() / 1000; 
        let set_coundown_sjc = new Date(this.set_coundown).getTime() / 1000; // 结束时间戳
        this.serverLastTime = set_coundown_sjc - (this.loca_timezone - timezoneOffset) * 3600; // 配平后的 时间戳 差值

        this.countdownTime = this.serverLastTime - this.serverNowTime; // 配平后的 时间戳 差值
    }

    // 启动倒计时
    startCountdown(){
        const update = (timestamp) => { //requestAnimationFrame 自带的timestamp参数 返回浏览器的毫秒数
            if(this.lastUpdateTime === 0){
                this.lastUpdateTime = timestamp; 
            }
            // 计算经过的时间
            const deltaTime = timestamp - this.lastUpdateTime;

            // 如果经过超过1秒，更新倒计时
            if (deltaTime >= 1000) {
                this.updateCountdown();
                this.lastUpdateTime = timestamp;  // 更新最后更新时间
            }

            if(!this.endDJS){
                // 继续调用requestAnimationFrame
                this.animationFrameId = requestAnimationFrame(update);
            }
            
        }
        this.animationFrameId = requestAnimationFrame(update); // 启动倒计时
    }
    // 更新倒计时
    updateCountdown(){
        
        const surplus = this.countdownTime;
        if(surplus >= 0){
            if(this.querySelector('.ug-countdown-div') && this.querySelector('.ug-countdown-div').classList.contains('dpn')){
                this.querySelector('.ug-countdown-div').classList.remove('dpn');
            }
            let serHour = parseInt(surplus/60/60);
            let serMin = surplus-serHour*60*60;
            serMin = parseInt(serMin/60);
            let serSec = surplus - serHour*60*60 - serMin*60;
            let serDays = "00";
            
            if(serMin<10){
                serMin = '0'+serMin;
            }
            if(serSec<10){
                serSec = '0'+serSec;
            }
            
            if(serHour>=24){
                serDays = Math.floor(serHour / 24);
                serDays = serDays<10 ? '0'+serDays : serDays;
                serHour = serHour % 24;
            }
            if(serHour<10){
                serHour = '0'+serHour;
            }
            // 更新UI，仅更新当前倒计时组件的 DOM 元素
            this.updateUI(serDays, serHour, serMin, serSec);
            console.log("倒计时更新："+serDays+'serDays ' + serHour+'serHour ' +serMin+'serMin '+serSec+'serSec')

            this.countdownTime--;  // 每次更新时减少1秒

        }else{
            this.stopCountdown();
        }

    }
    // 更新UI：仅更新当前自定义元素下的子元素
    updateUI(serDays, serHour, serMin, serSec) {
        const daysElement = this.querySelector('.countdown-days');
        const hoursElement = this.querySelector('.countdown-hours');
        const minutesElement = this.querySelector('.countdown-minutes');
        const secondsElement = this.querySelector('.countdown-seconds');

        if (daysElement) daysElement.textContent = serDays;
        if (hoursElement) hoursElement.textContent = serHour;
        if (minutesElement) minutesElement.textContent = serMin;
        if (secondsElement) secondsElement.textContent = serSec;
    }
    // 停止倒计时
    stopCountdown(){
        console.log('倒计时结束');
        this.endDJS = true;
        cancelAnimationFrame(this.animationFrameId);  // 停止 requestAnimationFrame
        // 如果回调函数已设置，执行回调
        if (this.stopAfterCallbackFn && typeof this.stopAfterCallbackFn === 'function') {
            this.stopAfterCallbackFn();  // 调用传递的回调函数
        }else{
            if(this.querySelector('.ug-countdown-div')){
                this.querySelector('.ug-countdown-div').classList.add('dpn');
            }
        }
    }

}

// 定义自定义元素
customElements.define('ug-countdown-timer', UGCountdownTimer);